document.addEventListener('DOMContentLoaded', () => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const menuItems = document.querySelectorAll('.header__inline-menu header-menu details');

  const closeMenu = (details) => {
    if (!desktopQuery.matches) return;

    details.classList.remove('cimtec-menu-opening');
    details.classList.remove('cimtec-menu-open');
    details.classList.add('cimtec-menu-closing');

    window.setTimeout(() => {
      if (!details.matches(':hover')) {
        details.removeAttribute('open');
        details.classList.remove('cimtec-menu-closing');
      }
    }, 340);
  };

  const openMenu = (details) => {
    if (!desktopQuery.matches) return;

    menuItems.forEach((item) => {
      if (item !== details) {
        item.classList.remove('cimtec-menu-opening');
        item.classList.remove('cimtec-menu-open');
        item.classList.remove('cimtec-menu-closing');
        item.removeAttribute('open');
      }
    });

    details.classList.remove('cimtec-menu-closing');
    details.classList.add('cimtec-menu-opening');
    details.setAttribute('open', '');

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        details.classList.add('cimtec-menu-open');
        details.classList.remove('cimtec-menu-opening');
      });
    });
  };

  menuItems.forEach((details) => {
    const summary = details.querySelector('summary');
    let closeTimer;

    details.addEventListener('mouseenter', () => {
      if (!desktopQuery.matches) return;

      clearTimeout(closeTimer);
      openMenu(details);
    });

    details.addEventListener('mouseleave', () => {
      if (!desktopQuery.matches) return;

      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        closeMenu(details);
      }, 90);
    });

    if (summary) {
      summary.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
      });
    }
  });

  window.addEventListener('resize', () => {
    if (desktopQuery.matches) return;

    menuItems.forEach((details) => {
      details.classList.remove('cimtec-menu-opening');
      details.classList.remove('cimtec-menu-open');
      details.classList.remove('cimtec-menu-closing');
      details.removeAttribute('open');
    });
  });
});

/* CIMTEC — Header transparente cuando está arriba */
document.addEventListener('DOMContentLoaded', () => {
  const updateHeaderTransparency = () => {
    if (window.innerWidth < 990) {
      document.body.classList.remove('cimtec-header-at-top');
      return;
    }

    if (window.scrollY <= 8) {
      document.body.classList.add('cimtec-header-at-top');
    } else {
      document.body.classList.remove('cimtec-header-at-top');
    }
  };

  updateHeaderTransparency();

  window.addEventListener('scroll', updateHeaderTransparency, { passive: true });
  window.addEventListener('resize', updateHeaderTransparency);
});